export default __webpack_public_path__ + "static/fax_compare_comp1_active-8ba75716298777c5b6f05cdfd75c4e23.png";